<template>
  <div class="card-info">
    <card v-if="init">
      <div class="text-center mt-3 mb-4">
        <img round width="140" src="@/assets/img/logo.png" alt="AVEDU" />
      </div>
      <h5 class="text-center">
        {{ "welcome" | setText("Добро пожаловать") }},
        {{ $store.state.user.full_name }}!
        <br />
        {{
          "step_to_start"
            | setText("Чтобы продолжить выберите или добавьте школу")
        }}
      </h5>
      <p class="text-center">
        {{ "account_number" | setText("Номер Вашего аккаунта") }}:
        {{ $store.state.user.phone }}
      </p>

      <h5 class="text-center" v-if="$store.state.user.is_root">
        {{
          "your_account_is_root"
            | setText(
              "Ваш аккаунт имеет статус ROOT, благодаря этому статусу  имеется доступ ко всем школам"
            )
        }}
      </h5>

      <div class="business">
        <set-language :title="`interface_language`"></set-language>
        <template>
          <p-button
            class="btn-lg"
            type="danger"
            @click.native.prevent="$modal.show('create-business')"
            >+ {{ "add_school" | setText("Добавить школу") }}
          </p-button>
          <ul>
            <li v-if="$store.state.user.is_root">
              <div class="business-title">
                {{ "control_center" | setText("Центр управления школами") }}
              </div>
              <p-button
                class="btn-sm"
                type="warning"
                @click.native.prevent="initRoot"
                >{{ "enter" | setText("Войти") }}
              </p-button>
            </li>

            <li v-for="business in businesses" :key="business.id">
              <div class="business-title">
                {{ business.id }} # {{ business.title }}
                <p class="text-success" v-if="business.is_active">
                  {{ "active" | setText("Активна") }}
                </p>
                <p class="text-danger" v-else>
                  {{ "noactive" | setText("Неактивна") }}
                </p>
              </div>
              <p-button
                class="btn-sm"
                type="warning"
                @click.native.prevent="initBusiness(business)"
                >{{ "enter" | setText("Войти") }}
              </p-button>
            </li>
          </ul>

          <div v-if="!businesses.length" class="mt-5">
            {{
              "you_have_no_school"
                | setText(
                  'У вас нет ни одной школы. Чтобы создать школу, нажмите "+Добавить школу" и ожидайте модерацию...'
                )
            }}
          </div>

          <div>
            <button @click="quit" class="quit">
              {{ "logout" | setText("Выход из системы") }}
            </button>
          </div>
        </template>
      </div>
    </card>
    <modal
      :name="`create-business`"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      :scrollable="true"
      :height="'auto'"
      :width="400"
    >
      <card>
        <div class="text-center mt-3 mb-4">
          <img round width="120" src="@/assets/img/logo.png" alt="AVTECH EDU" />
        </div>
        <form class="text-center">
          <h5>{{ "choose_school" | setText("Выберите школу") }}</h5>
          <selector :modal="'business'" v-model="business"> </selector>
          <br />
          <p-button
            class="w-100 mb-3"
            type="warning"
            round
            @click.native.prevent="create"
            >{{ "add" | setText("Добавить") }}</p-button
          >
          <p-button
            class="w-100 mb-3"
            type="info"
            round
            @click.native.prevent="$modal.hide('create-business')"
            >{{ "cancel" | setText("Отмена") }}</p-button
          >
        </form>
      </card>
    </modal>
    <!-- {{'school_has_been_added' | setText('Школа добавлена')}} -->

    <div class="m-4 text-center">
      Используя функционал платформы AVEDU, вы соглашаетесь с
      <span class="link" @click="$modal.show('policy')"
        >условиями политикой конфиденциальности</span
      >
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
export default {
  name: "business",

  data() {
    return {
      businesses: [],
      init: false,
      business: null,
    };
  },
  mounted() {
    localStorage.removeItem("bid");
    localStorage.removeItem("root");
    localStorage.removeItem("seasonId");
    this.$http.defaults.headers.common["bid"] = "";
    this.$http.defaults.headers.common["root"] = "";
    this.$store.dispatch("setBusiness", null);
    this.$store.dispatch("setRoot", false);
    this.$store.dispatch("setSeasons", []);
    try {
      this.$router.push("/");
    } catch (error) {}
  },
  created() {
    this.$loading(true);
    this.$http
      .get("accounts")
      .then((response) => {
        this.businesses = response.data.data;
      })
      .catch((error) => {
        errorNotify(error, this.$notify);
      })
      .finally(() => {
        this.init = true;
        setTimeout(() => {
          this.$loading(false);
        }, 200);
      });
  },
  methods: {
    create() {
      this.$loading(true);
      this.$http
        .post("accounts", { business: this.business })
        .then((response) => {
          this.$notify({
            title: this.$store.state.text["school_has_been_added"],
            message: this.$store.state.text["wait_moderation"],
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          this.businesses = response.data.data;
          this.$modal.hide("create-business");
          this.business = null;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    quit() {
      this.$http.defaults.headers.common["Authorization"] = null;
      this.$http.defaults.headers.common["root"] = null;
      this.$http.defaults.headers.common["bid"] = null;
      localStorage.removeItem("root");
      localStorage.removeItem("bid");
      localStorage.removeItem("token");
      this.$store.dispatch("setRoot", false);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setBusiness", null);
      this.$store.dispatch("setRoutes", []);
      try {
        this.$router.push("/dashboard");
      } catch (error) {}
    },
    initRoot() {
      localStorage.setItem("root", 1);
      this.$http.defaults.headers.common["root"] = 1;
      this.$store.dispatch("setRoot", true);
      this.$store.dispatch("setRoutes", this.$store.state.user.routes_root);

      try {
        this.$router.push("/dashboard");
      } catch (error) {}
    },
    initBusiness(business = null) {
      if (business && business.id) {
        this.$loading(true);
        this.$http
          .get(`accounts/${business.id}`)
          .then((response) => {
            let data = response.data.data;
            localStorage.setItem("bid", data.id);
            this.$http.defaults.headers.common["bid"] = data.id;
            this.$store.dispatch("setRoot", false);
            this.$store.dispatch("setBusiness", data);
            this.$store.dispatch("setRoutes", data.routes);


            this.$http
            .get(`${process.env.HOST_URL}/api/v3/schools/${data.id}/school_seasons`)
            .then((response) => {
              this.$store.dispatch("setSeasons", response.data.data);
              let seasonId = localStorage.getItem("seasonId");
              if(!seasonId){
                if(!response.data.data.length)
                  return
                seasonId = response.data.data.filter(e=>{return e.is_default})[0].id
                localStorage.setItem("seasonId", seasonId);
              }
              this.$http.defaults.headers.common["season-id"] = seasonId;
            }).catch((error)=>{
              console.log(error, 'error')
            })



            try {
              this.$router.push("/");
            } catch (error) {}
          })
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally(() => {
            this.$loading(false);
          });
      }
    },
  },
};
</script>
